import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const EyeInput = ({ accessor, onChange }) => {
  let [value, setValue] = useState(false);

  const onChng = () => {
    setValue(!value);
    onChange({ accessor, value: !value });
  };

  return <IconButton onClick={onChng}>{value ? <VisibilityIcon /> : <VisibilityOffIcon />}</IconButton>;
};

export default EyeInput;
